/*
  FAQ page — client-side search and category filtering.

  Filtering happens entirely in the DOM: every answer is server-rendered, so
  the page is crawlable and the FAQPage markup matches what a visitor can see.
  No network requests and no page reloads.

  Each row carries a prebuilt data-haystack (question + category + answer text,
  lowercased) so matching is a single indexOf rather than repeated DOM reads.
*/
(function () {
  function initFaq(root) {
    var input = root.querySelector('[data-faq-search]');
    var cats = Array.prototype.slice.call(root.querySelectorAll('[data-faq-cat]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('details.faq-q'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-faq-group]'));
    var count = root.querySelector('[data-faq-count]');
    var none = root.querySelector('[data-faq-none]');
    var clear = root.querySelector('[data-faq-clearall]');
    var active = 'all';

    if (!rows.length) return;

    function apply() {
      var q = ((input && input.value) || '').trim().toLowerCase();
      var matched = 0;

      rows.forEach(function (r) {
        var okCat = q || active === 'all' || r.getAttribute('data-faq-c') === active;
        var hay = r.getAttribute('data-faq-h') || '';
        var okText = !q || hay.indexOf(q) > -1;
        if (okCat && okText) {
          r.hidden = false;
          matched++;
        } else {
          r.hidden = true;
          r.open = false;
        }
      });

      // A category heading only shows while it still has a visible row under it.
      groups.forEach(function (g) {
        var key = g.getAttribute('data-faq-group');
        var any = rows.some(function (r) {
          return !r.hidden && r.getAttribute('data-faq-c') === key;
        });
        g.hidden = !any;
      });

      if (count) {
        var label = '';
        if (active !== 'all' && !q) {
          var btn = root.querySelector('[data-faq-cat="' + active + '"]');
          if (btn) label = ' in ' + (btn.getAttribute('data-faq-label') || '');
        }
        var safe = q.replace(/[<>&"]/g, '');
        count.innerHTML =
          '<b>' + matched + '</b> ' + (matched === 1 ? 'answer' : 'answers') +
          label + (q ? ' matching \u201c' + safe + '\u201d' : '');
      }

      if (none) none.classList.toggle('on', matched === 0);
      if (clear) clear.style.display = q || active !== 'all' ? 'inline' : 'none';
    }

    if (input) {
      input.addEventListener('input', apply);
      // Enter in a lone text input would submit an enclosing form; nothing to submit.
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') e.preventDefault();
      });
    }

    cats.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-faq-cat');
        active = active === key ? 'all' : key;
        cats.forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-faq-cat') === active ? 'true' : 'false');
        });
        apply();
      });
    });

    if (clear) {
      clear.addEventListener('click', function () {
        if (input) input.value = '';
        active = 'all';
        cats.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        apply();
        if (input) input.focus();
      });
    }

    // Answers cross-link to each other and the page can be shared with a #hash.
    // Opening the target is not enough — a filter may be hiding it — so reset
    // the filters first, then open and scroll.
    function openHash() {
      var id = (location.hash || '').slice(1);
      if (!id) return;
      var target = root.querySelector('details.faq-q[id="' + id.replace(/["\\]/g, '') + '"]');
      if (!target) return;
      if (input) input.value = '';
      active = 'all';
      cats.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      apply();
      target.open = true;
      target.scrollIntoView({ block: 'start' });
    }

    window.addEventListener('hashchange', openHash);
    apply();
    openHash();
  }

  // An autoplaying loop is motion, so anyone who has asked for less of it gets
  // the poster frame held still instead.
  function respectReducedMotion(root) {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.faq-hero-media video').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }

  function boot() {
    document.querySelectorAll('[data-faq]').forEach(function (root) {
      respectReducedMotion(root);
      initFaq(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
